let translationsANYIT = {
	forSell: 'For Sale',
	forRent: 'For Rent',
	flat: 'Flat',
	house: 'House',
	flatPlusHouse: 'Flat + House',
	garage: 'Garage',
	parcel: 'Parcel',
	projectEstate: 'Project Estate',
	office: 'Office',
	shop: 'Shop',
	tourism: 'Tourism',
	industrial: 'Industrial',
	agricultural: 'Agricultural',
	parcelForInnovation: 'Parcel For Innovation',
	publicInstitution: 'Public Institution',
	estatePlacePlaceholder: 'Search place',
	estateTypePlaceholder: 'Estate type',
	search: 'Search',
	officeSearchPlaceholder: 'Start typing...',
	officeSearchTitle: 'Office and adviser search',
	agents: 'Agents',
	offices: 'Offices',
	share: 'Share',
	filter: 'Filter',
	location: 'Location',
	price: 'Price',
	shareSubject: 'Share',
	en: 'English',
	hu: 'Hungarian',
	placeSearchTooltip: 'Max 6 place'
};

export default translationsANYIT;
